import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import Account from "./Account";
import AccountTransfer from "./AccountTransfer";

export default class Accounts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'account',
            popupComponent: null,
            data: null,
            tree: [],
            loading: true,
            id_to_remove: null,
            expandedIds: [],
            systemModuleId: 8,
            moduleAccessStatus: 1,
            menuId: 16
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Account Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Account Caller={this} /> });
    }
    onTransfer(id, accountType) {
        this.removeKeyDown();
        this.showComponents({ component: <AccountTransfer Caller={this} Id={id} OrganizationId={this.state.data.global.company.id} AccountType={accountType} /> });
    }
    refreshData() {
        //this.setState({ loading: true });
        this.httpPost("api/v1/" + this.state.controllerName + "/list/", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    importCoding(bussinesType) {
        this.setState({ loading: true });
        this.httpPost("api/v1/" + this.state.controllerName + "/import/", {
            organizationId: this.state.data.global.company.id,
            bussinesType
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("کدینگ با موفقیت ایجاد شد");
                    this.refreshData();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);
        
        return <div className="nk-content-body">
            <div className="nk-block">
                <div className="card card-bordered card-stretch">
                    <div className="card-inner-group">
                        <div className="card-inner p-4">
                            <div style={{ "padding": "2px 5px" }}>
                                <a className="btn btn-primary" onClick={e => this.onAdd()}><span style={{ "margin-left": "5px" }} className="fa fa-plus"></span> جدید</a>
                                <div className="drodown" style={{ "display": "inline-block", "margin": "0 0.5rem 0 0" }}>
                                    <a href="#" className="dropdown-toggle btn btn-icon btn-primary" data-bs-toggle="dropdown" aria-expanded="true" style={{ "padding-left": "10px" }}><em className="icon ni ni-plus"></em> ایمپورت کدینگ سیستمی</a>
                                    <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                        <ul className="link-list-opt no-bdr">
                                            <li><span className="hand" onClick={e => this.importCoding(1)}>ایمپورت کدینگ پیمانکاری</span></li>
                                            <li><span className="hand" onClick={e => this.importCoding(2)}>ایمپورت  کدینگ خدماتی</span></li>
                                            <li><span className="hand" onClick={e => this.importCoding(3)}>ایمپورت  کدینگ تولیدی</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <ul style={{ "padding-right": "0px", "color": "blue" }} className="mt-4">
                                {this.state.data.records.map(l1 =>
                                    l1.type === 1 &&
                                    <li>
                                        <span onClick={e => this.confirmRemove(l1.id)}><em className="icon ni ni-trash text-danger"></em></span>
                                        <span onClick={e => this.onEdit(l1.id)}><em className="icon ni ni-edit text-primary"></em></span>
                                        <span>{l1.title} - <b>{l1.fullCode}</b></span>
                                        <ul style={{ "padding-right": "20px", "color": "green" }}>
                                            {this.state.data.records.map(l2 =>
                                                l2.type == 2 && l2.parentCode == l1.fullCode &&
                                                <li>
                                                    <span onClick={e => this.confirmRemove(l2.id)}><em className="icon ni ni-trash text-danger"></em></span>
                                                    <span onClick={e => this.onEdit(l2.id)}><em className="icon ni ni-edit text-primary"></em></span>
                                                    <span>{l2.title} - <b>{l2.fullCode}</b></span>
                                                    <ul style={{ "padding-right": "40px", "color": "black" }}>
                                                        {this.state.data.records.map(l3 =>
                                                            l3.type == 3 && l3.parentCode == l2.fullCode &&
                                                            <li>
                                                                <span onClick={e => this.confirmRemove(l3.id)}><em className="icon ni ni-trash text-danger"></em></span>
                                                                    <span onClick={e => this.onEdit(l3.id)}><em className="icon ni ni-edit text-primary"></em></span>
                                                                    <span onClick={e => this.onTransfer(l3.id, l3.type)} title="انتقال حساب"><em className="icon ni ni-copy text-primary"></em></span>
                                                                <span>{l3.title} - <b>{l3.fullCode}</b></span>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                )}
                            </ul>
                            {/*<TreeView*/}
                            {/*    data={this.state.tree}*/}
                            {/*    expandedIds={this.state.expandedIds}*/}
                            {/*    className="basic"*/}
                            {/*    aria-label="basic example tree"*/}
                            {/*    nodeRenderer={({ element, getNodeProps, level, handleSelect }) => (*/}
                            {/*        <div className="hand" {...getNodeProps()} style={{ paddingRight: 20 * (level - 1), color: (element.metadata.type == 1 ? 'blue' : element.metadata.type == 2 ? 'green' : 'black') }}>*/}
                            {/*            <input type="checkbox" onChange={e => this.setSelectedRow(e.target.checked, element.id)} style={{ "margin-left": "10px" }} />*/}
                            {/*            <span onClick={e => this.confirmRemove(element.id)}><em className="icon ni ni-trash text-danger"></em></span>*/}
                            {/*            <span onClick={e => this.onEdit(element.id)}><em className="icon ni ni-edit text-primary"></em></span>*/}
                                        
                            {/*            {element.name} - <b>{element.metadata.fullCode}</b>*/}
                            {/*        </div>*/}
                            {/*    )}*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}